export default __webpack_public_path__ + "static/media/slot4.02c7fca3.png";